module.exports = __webpack_public_path__ + "media/fx-night.bcc78446.mp3";